import "./Panel.css";
import { type JSX, type ParentComponent, Show } from "solid-js";
import { nanoID } from "../utils/nanoID";
import { BasePanel, type Props } from "./BasePanel";
import { PanelHeader } from "./molecules/Panel/PanelHeader";

/**
 * Slide-out panel with header, icon, close button, and optional footer.
 *
 * [Design System →](http://localhost:5174/component/Panel)
 */
export const Panel: ParentComponent<Props & { subTitle?: JSX.Element }> = (
	props,
) => {
	const id = nanoID("gvtui-panel", 10);
	const close = () => {
		if (props.isOpen()) {
			props.onToggle();
		}
	};

	return (
		<BasePanel {...props} onToggle={close}>
			<PanelHeader
				title={props.title}
				subTitle={props.subTitle}
				symbol={props.symbol}
				titleContent={props.titleContent}
				onToggle={close}
				id={id}
			/>

			<div class="panel-content">{props.children}</div>
			<Show when={props.footer}>
				<footer>{props.footer}</footer>
			</Show>
		</BasePanel>
	);
};
